export const konvaSettings = {
    canvasOffset:  15,
	detailedCanvasOffset: 15,
    fillDarkColor: "#656565",
    fillGreyColor: '#e0e0e0',
    fillWhiteColor: 'white',
	fillHoverColor: '#969696',
    activeColor: 'red',
    blurColor: 'rgba(255, 255, 255, 0.9)',
    errorColor: '#b40003',
    inactiveProductColor: '#000',
    primaryColor: '#FF5A00',
    primaryBackgroundColor: '#ffdecc',
    wallColor: '#6d6d6d',
    wallActiveColor: '#2f2f2f',
    backgroundGreyColor: '#f5f5f5'
};